<div>
  @if (isPushApiEnabled) {
    <tab-bar [tabs]="tabs" [(currentTabId)]="currentTabId" (currentTabIdChange)="onTabChange($event)"></tab-bar>
  }
  <!-- BEG: API Key Management -->
  @if (isApiKeyManagementTabDisplayed) {
    <div>
      <rn-apikey-mgmt></rn-apikey-mgmt>
    </div>
  }
  <!-- END: API Key Management -->
  <!-- BEG: Push API Integration -->
  @if (isPushApiTabDisplayed) {
    <div>
      <rn-push-api></rn-push-api>
    </div>
  }
  <!-- END: Push API Integration -->
</div>